<template>
  <div class="box-cont">
    <div class="box">
      <div class="title">
        <el-page-header @back="goBack"></el-page-header>
        <div class="btn" >
          {{pageTitle}}
        </div>
      </div>
      <div class="cont">
        <div v-if="$route.query.storeType!=2&&$route.query.storeType!=3" class="row">
            <div class="name">所属题库：</div>
            <div class="inputA">
                <el-select v-model="form.storeId" placeholder="请选择">
                    <el-option
                    v-for="item in options"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                    </el-option>
                </el-select>
            </div>
        </div>
        <div class="row">
            <div class="name">题型：</div>
            <div class="inputA">
                <el-radio v-model="form.questType" label="1">单选题</el-radio>
                <el-radio v-model="form.questType" label="2">多选题</el-radio>
                <el-radio v-model="form.questType" label="3">判断题</el-radio>
            </div>
        </div>
        <div class="row">
            <div class="name">题目：</div>
            <div class="inputA" style="width: 26vw;">
                <el-input type="textarea" v-model="form.questWord"></el-input>
            </div>
        </div>
        <div class="row">
            <div class="name">题目解析：</div>
            <div class="inputA" style="width: 26vw;">
                <el-input type="textarea" v-model="form.questAnalysis"></el-input>
            </div>
        </div>
        <div class="row1">
            <div class="name" style="height:20px">选项：</div>
            <div class="inputB">
                <div class="listB" v-for="(item,index) in questOpt" :key="index">
                    <div class="B-top">
                        <div style="display:flex;width:60%">
                            <div class="xuanxiang">{{item.letter}}</div>
                            <div class="xuanxiang">是否是答案</div>
                            <div>
                                <el-radio v-model="item.coverType" label="0">是</el-radio>
                                <el-radio v-model="item.coverType" label="1">否</el-radio>
                            </div>
                        </div>
                        <div v-if="questOpt.length>1" style="display:flex;width:22%;justify-content: space-between;">
                            <div class="btn1" @click="addQ">添加</div>
                            <div class="btn1" @click="delOpt(item.index)">删除</div>
                        </div>
                        <div v-else style="display:flex;width:22%;justify-content: space-between;">
                            <div></div>
                            <div class="btn1" @click="addQ">添加</div>
                        </div>
                    </div>
                    <div class="B-bottom" style="margin-top:10px">
                        <el-input type="textarea"  v-model="item.opWord" rows="3" class="opWord" ></el-input>
                    </div>
                </div>
            </div>
        </div>
        <div class="row2">
            <div class="btn-l" @click="goBack()">返回</div>
            <div class="btn-r" @click="submitForm">提交</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import util from '../../../untils/util';
import myHttp from '../../../untils/port';
  export default {
    data(){
        return{
            form:{
                id:'',
                storeId:'',
                questType:'1',
                questWord:'',
                answer:'',
                optionJson:'',
                questAnalysis:'',
                
            },
            options:[],
            groupId:'',
            zim:['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H'],
            questOpt:[{
                index:1,
                letter:'A',
                coverType:'1',
                opWord:'',
                
            }],
            pageTitle:'',
            tmid:''
        }
    },
    mounted(){
        if(this.$route.query.storeType==2){
            this.form.groupId=util.session.get('groupId')
            this.groupId=util.session.get('groupId')
        }
        var params = this.$route.query.id;
        this.pageTitle ='添加题目'
        if(params!=0&&params!=''){
            this.form.id = params;
            this.pageTitle ='修改题目'
        }
        this.tmid=this.$route.query.tmid||''
        if(this.tmid!=''){
            this.form.storeId = this.tmid
        }
        this.groupId = util.session.get('groupId');
        if(util.session.get('roleId')=='3'){
            this.groupType = '3';
        }else if(this.$store.state.roleId=='4'){
            this.groupType = '1';
        }else if(this.$store.state.roleId=='5'){
            this.groupType = '2';
        }
        
        this.getStore();
        if(this.form.id!=''){
            this.getData();
        }
    },
    methods:{
         getStore(){
            var that = this;
            myHttp.getAllStore({
                groupId:this.groupId,
                groupType:this.groupType,
                module:this.$route.query.module,
                storeType:this.$route.query.storeType
            }).then(function(resp){
                console.log(resp)
                if(resp.data.code=="200"){
                    that.options = resp.data.data.storeList||[];
                }
            });
        },
        //根据id获取数据
        getData(){
            var that = this;
            myHttp.getExamById({
                id:this.form.id
            }).then(function(resp){
                if(resp.data.code=="200"){
                    var data = resp.data.data.question;
                    that.form.storeId = data.storeId;
                    that.form.questType = data.questType;
                    that.form.questWord = data.questWord;
                    that.form.questAnalysis = data.questAnalysis
                    var daAn = data.answer.split(",");
                    var list = data.options;
                    var newList = [];
                    for(var i=0;i<list.length;i++){
                        var index = that.zim.indexOf(list[i].opOption)+1;
                        var sel = daAn.indexOf(list[i].opOption)<0?'1':'0';
                        var sub = {
                            index:index,
                            letter:list[i].opOption,
                            opWord:list[i].opWord,
                            coverType:sel
                        }
                        newList.push(sub);
                    }
                    that.questOpt = newList;
                }
            });
        },
        //添加答案
        addQ(){
            if(this.questOpt.length>=6){
                this.$message.error('答案最多有6个');
                return;
            }
            var index = 1;
            var letter = 'A';
            var length = this.questOpt.length;
            if(length>0){
                var cur = this.questOpt[length-1].index;
                index = parseInt(cur) + 1;
                letter =this.zim[length];
            }
            var option = {
                index:index,
                letter:letter,
                coverType:'1',
                opWord:''
            }
            this.questOpt.push(option);
            console.log(this.questOpt);
        },
        //删除
        delOpt(val){
            var old = this.questOpt;
            var list = [];
            var setId = 1;
            for(var i=0;i<old.length;i++){
                if(val!=old[i].index){
                    old[i].index = setId;
                    old[i].letter = this.zim[parseInt(setId)-1];
                    list.push(old[i]);
                    setId++;
                }
            }
            this.questOpt = list;
        },
        //返回
        goBack(){
            this.$router.go(-1)
        },
        //提交
        submitForm(){
            var that = this;
            var list = this.questOpt;
            var isFlag = true;//判断是否只有一个答案
            var obj = [];
            for(var i=0;i<list.length;i++){
                var sub = { opOption: '', opWord: '' }
                sub.opOption = list[i].letter;
                sub.opWord = list[i].opWord;
                obj.push(sub);
                var isAns = list[i].coverType;
                if (isAns == '0' && this.form.answer == '') {
                    this.form.answer = sub.opOption;
                } else if (isAns == '0' && this.form.answer != '' && this.form.questionType == '1' || isAns == 0 && this.form.answer != '' && this.form.questionType == '3') {
                    isFlag = false;
                    this.$message.error('单选题或者判断题只能有一个答案');
                    break;
                } else if (isAns == 0) {
                    this.form.answer = this.form.answer + "," + sub.opOption;
                }
            }
            if (obj.answer == '') {
                this.$message.error('请选择答案');
                return;
            } else if (!isFlag) {
                return;
            } else{
                this.form.optionJson = JSON.stringify(obj);
                if(this.form.id==''){
                    myHttp.appExamSave(this.form).then(function (resp) {
                        if (resp.data.code == "200") {
                            that.$message.success('添加成功');
                            that.reload();
                            that.questOpt = [{
                                index:1,
                                letter:'A',
                                coverType:'1',
                                opWord:'',
                            }]
                        } else {
                            that.$message.error(resp.data.msg);
                            return;
                        }
                    }, function (error) {
                        that.$message.error("服务器繁忙，请稍候再试");
                    });
                }else{
                    myHttp.appExamForm(this.form).then(function (resp) {
                        if (resp.data.code == "200") {
                            that.$message.success('修改成功');
                            that.reload();
                            that.questOpt = [{
                                index:1,
                                letter:'A',
                                coverType:'1',
                                opWord:'',
                                questAnalysis:''
                            }]
                        } else {
                            that.$message.error(resp.data.msg);
                            return;
                        }
                    }, function (error) {
                        that.$message.error("服务器繁忙，请稍候再试");
                    });
                }
            }
        },

        //
        reload(){
            this.form = {
                id:'',
                storeId:'',
                questType:'1',
                questWord:'',
                answer:'',
                optionJson:''
            }
            if(this.groupId!=''){
                this.form.groupId=this.groupId
            }
        },
    } 
  }
</script>

<style scoped>
.box-cont{
  width: 100%;
  height: 100%;
  background-color: #ECF0F5;
  padding: 12px 24px 10px 8px;
}
.box{
  width: 100%;
  height: 100%;
  border-radius: 6px;
  background: #FFFFFF;
  box-shadow: 0px 4px 10px 0px rgba(77, 110, 177, 0.3);
  overflow: hidden;
}
.title{
  height: 6vh;
  border-bottom: 2px solid #D8D8D8;
  padding-left: 2%;
  display: flex;
  justify-content: start;
  align-items: center;
}
.btn{
  font-family: SourceHanSansCN-Regular;
font-size: 16px;
font-weight: normal;
letter-spacing: 0em;
color: #666666;
}
.text{
  margin-top: 10%;
}
.cont{
    padding-left: 4%;
    height: 83vh;
    overflow: auto;
    padding-bottom: 50px;
}
.row{
    margin-top: 16px;
    display: flex;
    align-items: center;
}
.row1{
    margin-top: 16px;
    display: flex;

}
.name{
    width: 9vw;
    text-align: end;
    margin-right: 10px;
    font-family: SourceHanSansCN-Regular;
font-size: 16px;
font-weight: normal;
letter-spacing: 0em;
color: #9E9E9E;
}

.B-top{
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 26vw;
}
.xuanxiang{
    margin-right: 32px;
    font-family: SourceHanSansCN-Normal;
font-size: 14px;
font-weight: 350;
letter-spacing: 0em;
color: #666666;
}


.btn1{
    width: 50px;
height: 24px;
border-radius: 4px;
background: rgba(227, 233, 246, 0.05);
box-sizing: border-box;
border: 1px solid rgba(153, 153, 153, 0.8);
font-family: SourceHanSansCN-Regular;
font-size: 14px;
font-weight: normal;
letter-spacing: 0em;
color: #8EA3CE;
}
.btn1:hover{
    opacity: 0.7;
    cursor: pointer;
}
.listB{
    margin-bottom:10px
}
.row2{
    display: flex;
    justify-content: start;
    align-items: center;
    margin-left: 11.3%;
    margin-top: 32px;
}
.btn-l{
    width: 55px;
height: 28px;
border-radius: 2px;
background: #FFFFFF;
box-sizing: border-box;
border: 1px solid #999999;
font-family: SourceHanSansCN-Normal;
font-size: 14px;
font-weight: 350;
letter-spacing: 0em;
color: #666666;
display: flex;
justify-content: center;
align-items: center;
}
.btn-l:hover{
    cursor: pointer;
    opacity: 0.7;
}
.btn-r{
    margin-left: 32px;
    width: 55px;
height: 28px;
border-radius: 2px;
background: #4D6EB1;
font-family: SourceHanSansCN-Normal;
font-size: 14px;
font-weight: 350;
letter-spacing: 0em;
color: #FFFFFF;
display: flex;
justify-content: center;
align-items: center;
}
.btn-r:hover{
    cursor: pointer;
    opacity: 0.7;
}
</style>